export const ORDER_AT = 'orderedAt';
export const SAMPLE_KIT_ORDER_ID = 'sampleKitOrderId';
export const SAMPLE_KIT_STATUS_ID = 'sampleKitOrderStatusId';
export const CONTROL_CODE = 'controlCode';
